<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini" ref="form" @submit.native.prevent="onSubmit">
            <el-form-item label="店铺ID：" class="query-form-item">
                <el-input v-model="query.sid" placeholder="请输入店铺ID" clearable></el-input>
            </el-form-item>
            <el-form-item label="店铺名称：" class="query-form-item">
                <el-input v-model="query.name" placeholder="请输入店铺名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="国家：" class="query-form-item">
                <el-input v-model="query.country" placeholder="请输入国家" clearable></el-input>
            </el-form-item>
            <el-form-item label="是否授权广告：" class="query-form-item">
                <el-select v-model="query.has_ads_setting" placeholder="状态" style="width: 100px">
                    <el-option label="全部" :value="null"></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态：" class="query-form-item">
                <el-select v-model="query.status" placeholder="状态" style="width: 100px">
                    <el-option label="全部" :value="null"></el-option>
                    <el-option label="正常" :value="1"></el-option>
                    <el-option label="停止同步" :value="0"></el-option>
                    <el-option label="授权异常" :value="2"></el-option>
                    <el-option label="欠费停服" :value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否获取数据：" class="query-form-item">
                <el-select v-model="query.used" placeholder="状态" style="width: 100px">
                    <el-option label="全部" :value="null"></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否铺货中：" class="query-form-item">
                <el-select v-model="query.using" placeholder="状态" style="width: 100px">
                    <el-option label="全部" :value="null"></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button type="primary" icon="search" @click="onSubmit" native-type="submit">查询</el-button>
                <!--                <el-button type="primary" @click.native="handleForm(null,null)">新增</el-button>-->
            </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="list" stripe border :height="tableHeight">
            <el-table-column
                    label="店铺ID"
                    prop="sid" align="center"
                    width="80px">
            </el-table-column>
            <el-table-column
                    label="店铺名" align="center"
                    prop="name">
            </el-table-column>
            <el-table-column
                    label="店铺账户名称" align="center"
                    prop="account_name">
            </el-table-column>

            <el-table-column
                    label="站点" align="center"
                    prop="region">
            </el-table-column>

            <el-table-column label="商城所在国" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.country }}</div>
                </template>
            </el-table-column>

            <el-table-column label="是否授权广告" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.has_ads_setting == 1 ? '是' : '否' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="状态" width="90" align="center">
                <template slot-scope="scope">
                    <div>{{ statusObj[scope.row.status] || '' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="是否获取数据" align="center">
                <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.used" @change="handleChange(scope.row)" :loading="formLoading"/>
                </template>
            </el-table-column>

            <el-table-column label="是否铺货中" align="center">
                <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.using" @change="handleChange(scope.row)" :loading="formLoading"/>
                </template>
            </el-table-column>

            <!--            <el-table-column-->
            <!--                label="操作"-->
            <!--                width="150"-->
            <!--                align="center"-->
            <!--                fixed="right">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <el-button type="success" @click.native="handleForm(scope.$index, scope.row)" size="mini">编辑-->
            <!--                    </el-button>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
        </el-table>

        <el-pagination
                background
                :page-size="query.limit"
                style="float: right;margin-top: 20px; margin-bottom: 22px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[20, 50, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="query.page"
                :total="total">
        </el-pagination>

        <!--表单-->
        <el-dialog
                title=""
                :visible.sync="formVisible"
                :before-close="hideForm"
                width="600px"
                top="5vh">
            <el-form :model="formData" ref="dataForm" label-width="120px">

                <el-form-item label="是否获取数据：">
                    <el-checkbox v-model="formData.used"></el-checkbox>
                </el-form-item>

                <el-form-item label="是否铺货中：">
                    <el-checkbox v-model="formData.using"></el-checkbox>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm" size="mini">取消</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading" size="mini">提交
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import * as api from '@/api/advAnalys/advAnalys.js'
    import {authAdminSave} from '@/api/auth/authAdmin'
    import {shoplistEdit} from '@/api/advAnalys/advAnalys.js'

    export default {
        mounted() {
            this.tableHeight =
                window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
            const that = this
            window.onresize = () => {
                return (() => {
                    if (typeof that.$refs.form == 'object') {
                        that.tableHeight =
                            window.innerHeight -
                            140 -
                            that.$refs.form.$el.offsetHeight
                    }
                })()
            }
        },
        data() {
            return {
                tableHeight: null,
                roles: [],
                query: {
                    sid: '',
                    name: '',
                    country: null,
                    has_ads_setting: null,
                    status: null,
                    using: null,
                    used: null,
                    page: 1,
                    limit: 20,
                },
                list: [],
                total: 0,
                loading: false,
                formLoading: false,
                formVisible: false,
                statusObj: {0: '停止同步', 1: '正常', 2: '授权异常', 3: '欠费停服',},
                formData: {},
            }
        },
        methods: {
            // 显示表单
            handleForm(index, row) {
                this.formVisible = true
                if (row !== null) {
                    this.formData = Object.assign({}, row)
                }
                this.formName = 'add'
                if (index !== null) {
                    this.index = index
                    this.formName = 'edit'
                }
            },
            handleChange(row) {
                this.formLoading = true
                let data = Object.assign({}, row)
                data.using = data.using ? 1 : 0
                data.used = data.used ? 1 : 0
                api.shoplistEdit(data).then(response => {
                    this.formLoading = false
                    if (response.code) {
                        this.$message.error(response.message)
                        return false
                    }
                    this.$message.success('操作成功')
                    this.formVisible = false
                    this.getList()
                    this.resetForm()
                }).catch(() => {
                    this.formLoading = false
                })
            },
            formSubmit() {
                this.formLoading = true
                let data = Object.assign({}, this.formData)
                data.using = data.using ? 1 : 0
                data.used = data.used ? 1 : 0
                api.shoplistEdit(data).then(response => {
                    this.formLoading = false
                    if (response.code) {
                        this.$message.error(response.message)
                        return false
                    }
                    this.$message.success('操作成功')
                    this.formVisible = false
                    this.getList()
                    this.resetForm()
                }).catch(() => {
                    this.formLoading = false
                })
            },
            // 刷新表单
            resetForm() {
                if (this.$refs['dataForm']) {
                    // 清空验证信息表单
                    this.$refs['dataForm'].clearValidate()
                    // 刷新表单
                    this.$refs['dataForm'].resetFields()
                }
            },
            // 隐藏表单
            hideForm() {
                // 更改值
                this.formVisible = !this.formVisible
                // 清空表单
                this.$refs['dataForm'].resetFields()
                return true
            },
            onReset() {
                this.query = {
                    sid: '',
                    name: '',
                    country: null,
                    using: null,
                    used: null,
                    page: 1,
                    limit: 20,
                    total: 0
                }
                this.getList()
            },
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            getList() {
                this.loading = true
                api.shoplistIndex(this.query).then(response => {
                    this.loading = false
                    this.list = (response.data.list || []).map(item => {
                        item.using = item.using === 1
                        item.used = item.used === 1
                        return item
                    })
                    this.total = response.data.total || 0
                }).catch(() => {
                    this.loading = false
                    this.list = []
                    this.total = 0
                })
            },
        },
        created() {
            this.getList()
        }
    }
</script>

<style type="text/scss" lang="scss">
</style>
